export default __webpack_public_path__ + "static/media/fulllogo3.jpg.b2d94e16.svg";